import { Box } from "@mui/material";
import {
  MONO,
  TEXT_DARK,
  TEXT_SUBTLE,
  BG_WHITE,
  BORDER,
  RADIUS_TILE,
  KPI_SHADOW,
  SUCCESS_FG,
  SUCCESS_BG,
  ERROR_FG,
  ERROR_BG,
  cardLabelSx,
} from "./bentoTokens";

// Small +/-% delta pill, matching scenes/financial's TrendBadge.
export function TrendBadge({ value }) {
  if (value === null || value === undefined) return null;
  const up = value >= 0;
  const color = up ? SUCCESS_FG : ERROR_FG;
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        background: up ? SUCCESS_BG : ERROR_BG,
        color,
        fontSize: 12,
        fontWeight: 700,
        fontFamily: MONO,
        padding: "4px 9px",
        borderRadius: "999px",
      }}
    >
      <Box
        component="span"
        sx={{
          display: "inline-block",
          width: 5,
          height: 5,
          borderRight: `1.8px solid ${color}`,
          borderTop: `1.8px solid ${color}`,
          transform: up ? "rotate(-45deg)" : "rotate(135deg)",
        }}
      />
      {up ? "+" : ""}
      {value.toFixed(1)}%
    </Box>
  );
}

// Small bento-style stat tile: uppercase label + bold mono value, optional trend badge,
// optional caption line, optional click-through for drill-down navigation.
const KpiTile = ({ label, value, trend, caption, valueColor = TEXT_DARK, onClick, icon, sx }) => (
  <Box
    onClick={onClick}
    sx={{
      background: BG_WHITE,
      border: `1px solid ${BORDER}`,
      borderRadius: RADIUS_TILE,
      boxShadow: KPI_SHADOW,
      p: "18px 20px",
      cursor: onClick ? "pointer" : "default",
      transition: "filter .15s",
      "&:hover": onClick ? { filter: "brightness(.97)" } : undefined,
      ...sx,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Box sx={cardLabelSx}>{label}</Box>
      {icon}
    </Box>
    <Box sx={{ display: "flex", alignItems: "baseline", gap: "10px", mt: "8px" }}>
      <Box sx={{ fontFamily: MONO, fontSize: 26, fontWeight: 700, color: valueColor, letterSpacing: "-.01em" }}>
        {value}
      </Box>
      <TrendBadge value={trend} />
    </Box>
    {caption && (
      <Box sx={{ fontSize: 11.5, color: TEXT_SUBTLE, mt: "2px" }}>{caption}</Box>
    )}
  </Box>
);

export default KpiTile;
